import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';

@Injectable()
export class RedirectGuard implements CanActivate {

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {

    window.location.href = route.data['externalUrl'];
    return true;

  }

}
